import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
// import { connect } from 'react-redux';
// import { bindActionCreators } from 'redux';

import GenericButton from '../../../common/GenericButton';
import GenericSearch from '../../../common/GenericSearch';
import AccountListItems from './AccountListItems';

class AccountMultiSelect extends Component {
  static propTypes = {
    accounts: PropTypes.instanceOf(Array),
    activeAccounts: PropTypes.instanceOf(Array),
    updateSelectedItems: PropTypes.func,
    clearAccount: PropTypes.bool,
    accountsRights: PropTypes.instanceOf(Array),
    isSuperUser: PropTypes.bool,
    selectedUser: PropTypes.instanceOf(Array),
  };

  static defaultProps = {
    accounts: [],
    activeAccounts: [],
    clearAccount: false,
    accountsRights: [],
    isSuperUser: false,
  };

  state = {
    items: [],
    itemsLeft: [],
    selectedItemsLeft: [],
    itemsRight: [],
    selectedItemsRight: [],
    rightSelectionCount: 0,
  };

  UNSAFE_componentWillMount() {
    const accounts = this.renderAccountData();
    const selectedItemsLeft = [];
    accounts.map((account, i) => {
      if (account.isActive) {
        selectedItemsLeft.push(i);
      }
      return null;
    });
    this.setState(
      { items: accounts, itemsLeft: accounts, selectedItemsLeft },
      () => {
        if (selectedItemsLeft.length > 0) {
          this.addSelected();
        }
      }
    );
  }

  UNSAFE_componentWillReceiveProps({ clearAccount }) {
    if (clearAccount !== this.props.clearAccount) {
      this.removeAll();
    }
  }
  renderAccountData = () => {
    const accounts = this.props.accounts;
    const activeAccounts = this.props.activeAccounts;
    const accountsRights = this.props.accountsRights;
    const isSuperUser = this.props.isSuperUser;
    const items = accounts.map((account, index) => {
      const activeAccount = _.filter(
        activeAccounts,
        item => item.accountId === account.accountId
      );
      const accountsRight =
        _.filter(
          accountsRights,
          item => item.accountId === account.accountId && item.accessType
        ).length || isSuperUser;
      const selected = activeAccount.length > 0;
      const availableSeats = account.maximumSeats - account.occupiedSeats;
      const isTPAccount = account.accountType === 'TPP' ? true : false;
      const items = {
        ...account,
        id: index,
        productNo: account.accountId,
        text: account.accountName,
        selected: false,
        isActive: selected,
        availableSeats,
        accountsRight,
        isTPAccount,
      };
      return items;
    });
    return items;
  };

  handleSearch = searchResult => this.setState({ itemsLeft: searchResult });

  handleLeftPanelClick = (id, clearExisting, shiftKey) => {
    let selectedItems = [];
    if (!shiftKey) {
      if (!clearExisting) {
        selectedItems = this.state.selectedItemsLeft;
      }
      selectedItems.push(parseInt(id, 10));
      this.setState({
        selectedItemsLeft: selectedItems,
      });
    } else {
      selectedItems = this.state.selectedItemsLeft;
      let lastItem = this.state.selectedItemsLeft.pop();
      let currentItemId = id;
      if (lastItem > currentItemId) {
        const temp = lastItem;
        lastItem = currentItemId;
        currentItemId = temp;
      }
      this.state.itemsLeft.map(item => {
        if (item.id >= lastItem && item.id <= parseInt(currentItemId, 10)) {
          selectedItems.push(item.id);
        }
        return item;
      });
      this.setState({
        selectedItemsLeft: selectedItems,
      });
    }
  };

  addSelected = () => {
    const selections = [];
    const itemsRemaining = [];
    this.state.itemsLeft.map(item => {
      if (item.selected) {
        selections.push(item);
      } else {
        itemsRemaining.push(item);
      }
      return item;
    });

    this.state.itemsRight.map(item => {
      selections.push(item);
      return item;
    });
    this.setState(
      {
        itemsLeft: itemsRemaining,
        itemsRight: selections,
        rightSelectionCount: selections.length,
        selectedItemsRight: [],
        selectedItemsLeft: [],
      },
      () => {
        this.props.updateSelectedItems(this.state.itemsRight);
      }
    );
  };

  removeSelected = () => {
    const selections = [];
    const itemsRemaining = [];
    this.state.itemsRight.map(item => {
      if (item.selected) {
        selections.push(item);
      } else {
        itemsRemaining.push(item);
      }
      return item;
    });

    this.state.itemsLeft.map(item => {
      selections.push(item);
      return item;
    });
    this.setState(
      {
        itemsLeft: selections,
        itemsRight: itemsRemaining,
        rightSelectionCount: itemsRemaining.length,
        selectedItemsRight: [],
        selectedItemsLeft: [],
      },
      () => {
        this.props.updateSelectedItems(this.state.itemsRight);
      }
    );
  };

  removeAll = () => {
    const leftPanelItems = [];
    leftPanelItems.push(...this.state.itemsLeft, ...this.state.itemsRight);
    this.setState(
      {
        itemsRight: [],
        itemsLeft: leftPanelItems,
        rightSelectionCount: 0,
        selectedItemsRight: [],
        selectedItemsLeft: [],
      },
      () => {
        this.props.updateSelectedItems(this.state.itemsRight);
      }
    );
  };

  handleRightPanelClick = (id, clearExisting, shiftKey) => {
    let selectedItems = [];
    if (!shiftKey) {
      if (!clearExisting) {
        selectedItems = this.state.selectedItemsRight;
      }
      selectedItems.push(parseInt(id, 10));
      this.setState({
        selectedItemsRight: selectedItems,
      });
    } else {
      selectedItems = this.state.selectedItemsRight;
      let lastItem = this.state.selectedItemsRight.pop();
      let currentItemId = id;
      if (lastItem > currentItemId) {
        const temp = lastItem;
        lastItem = currentItemId;
        currentItemId = temp;
      }
      this.state.itemsRight.map(item => {
        if (item.id >= lastItem && item.id <= parseInt(currentItemId, 10)) {
          selectedItems.push(item.id);
        }
        return item;
      });
      this.setState({
        selectedItemsRight: selectedItems,
      });
    }
  };

  renderSearchItems = () => {
    const { items, itemsRight } = this.state;
    const filteredItems = [];
    _.map(items, item => {
      const hasItem = _.filter(itemsRight, k => k.accountId === item.accountId);
      if (_.isEmpty(hasItem)) {
        filteredItems.push(item);
      }
    });
    return filteredItems;
  };
  render() {
    return (
      <div>
        <div className="trend-search-component">
          <div className="add-user-form--row">
            <div className="add-user-form--col">
              <GenericSearch
                searchItems={this.renderSearchItems()}
                searchField="text"
                handleSearchResult={this.handleSearch}
                placeholder="Search Account..."
              />
            </div>
          </div>
        </div>
        <div className="add-user-form--row">
          <div className="add-user-form--col">
            <AccountListItems
              items={this.state.itemsLeft}
              selectedItems={this.state.selectedItemsLeft}
              handleSelection={this.handleLeftPanelClick}
              selectedUser={this.props.selectedUser}
            />
          </div>
          <div className="add-user-form--col-center add-user-form--col">
            <div className="stacked button-group multi-select-button-group">
              <GenericButton
                name=" "
                btnStyle="button btn-add btn-priaryDisable"
                onBtnClick={this.addSelected}
                {...(this.state.selectedItemsLeft.length < 1
                  ? { btnDisabled: true }
                  : {})}
              />
              <GenericButton
                name=" "
                btnStyle="button btn-remove btn-cncl"
                onBtnClick={this.removeSelected}
                {...(this.state.selectedItemsRight.length < 1
                  ? { btnDisabled: true }
                  : {})}
              />
            </div>
          </div>
          <div className="add-user-form--col">
            <AccountListItems
              items={this.state.itemsRight}
              selectedItems={this.state.selectedItemsRight}
              handleSelection={this.handleRightPanelClick}
              isSelectedBox
              selectedUser={this.props.selectedUser}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default AccountMultiSelect;
